'use client';
import { CN_PRODUCT } from '@/components/product/const';
import { PropsWithChildren, useEffect, useState } from 'react';

import { queryPlatMind } from '@/apis/dp/service';
import { dataExpTagConfig } from '@/components/product/const';
import ArrowIcon from '@/images/icon/arrow-default.svg';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25217';
// styles

import { AssuranceWrapper } from '@/styles/product';
import { imageUtil } from '@/utils/imageUtil';
import { ErrorBoundary } from 'react-error-boundary';
import AgeVerification from './verifyAge';
import { useComponentMonitor } from '@/components/componentMoniter/clientMonitor';

const Accordion = ({
  noBottomBorder,
  children,
}: { noBottomBorder?: boolean } & PropsWithChildren) => {
  return (
    <div className={`${CN_PRODUCT('sku-assurance')} ${noBottomBorder ? 'noBottomBorder' : ''}`}>
      {children}
    </div>
  );
};
// styles

function Assurance({ floors, skuId }: any) {
  const [isClient, setIsClient] = useState(false);
  const productShipPromiseFloor = floors.productShipPromiseFloor?.data;
  // const guarantee = productShipPromiseFloor?.["C-M#viewAddressItem&guarantee"]?.items;
  const guarantee = floors?.productGuaranteeFloor?.data;
  // productComplianceFloor 烟酒年龄限制

  const productComplianceFloor = floors.productComplianceFloor?.data;
  const recycling = productShipPromiseFloor?.recycle;

  useEffect(() => {
    setIsClient(true);
  }, []);

  const [collapseActive, setCollapseActive] = useState<Record<string, boolean>>({
    weAccept: true,
  });
  const [weAccept, setWeAccept] = useState<any>();

  const ageRef = useComponentMonitor({
    name: 'AgeVerification', // 组件名（日志标识）
    shouldShow: () => !!productComplianceFloor?.title, // 渲染条件：有用户信息才渲染
    logData: { page: 'dp', message: productComplianceFloor },
  });

  const onGuaranteeClick = (index: number | string, text?: string) => {
    if (text) {
      sendClickTrack.Productdetail_BasicServiceFloor_Click({
        mainskuid: skuId,
        displayText: text,
      });
    }
    setCollapseActive({ ...collapseActive, [index]: !collapseActive[index] });
  };
  const initQueryPlatMind = async () => {
    const res = await queryPlatMind();
    setWeAccept(res);
  };

  useEffect(() => {
    initQueryPlatMind();
  }, []);

  return (
    <AssuranceWrapper>
      {guarantee?.title && <h2 className='accordion-title'>{guarantee?.title}</h2>}
      {guarantee?.items?.map((item: any, index: number) => {
        const styles = !collapseActive[index] ? { height: 0 } : {};
        const { logoUrl } = item || {};
        if (!item?.title) {
          return null;
        }
        return (
          <Accordion key={index}>
            {/* {JSON.stringify(item)} */}
            <div
              className={`accordion-summary ${!collapseActive[index] ? 'expanded' : ''}`}
              onClick={() => onGuaranteeClick(index, item.title)}
              exptag={'exp|' + EXPOSURE_RECORD.Productdetail_BasicServiceFloor_Expo}
              data-exptag-config={dataExpTagConfig}
              data-exptag-json-param={JSON.stringify({ mainskuid: skuId, displayText: item.title })}
            >
              {/* {logoUrl && <CDNImage src={logoUrl} width={20} height={20} alt="icon" />} */}
              <p>{item.title}</p>
              <div className='arrow-wrapper'>
                <ArrowIcon />
              </div>
            </div>
            <div className='accordion-detail' style={styles}>
              {isClient && (
                <p
                  className='content common-editor'
                  dangerouslySetInnerHTML={{ __html: item.content }}
                ></p>
              )}
            </div>
          </Accordion>
        );
      })}

      {recycling && (
        <Accordion key='recycling'>
          <div
            className={`accordion-summary ${!collapseActive['recycling'] ? 'expanded' : ''}`}
            onClick={() => onGuaranteeClick('recycling', recycling.title)}
            exptag={'exp|' + EXPOSURE_RECORD.Productdetail_BasicServiceFloor_Expo}
            data-exptag-config={dataExpTagConfig}
            data-exptag-json-param={JSON.stringify({
              mainskuid: skuId,
              displayText: recycling.title,
            })}
          >
            {/* {logoUrl && <CDNImage src={logoUrl} width={20} height={20} alt="icon" />} */}
            <p>{recycling.title}</p>
            <div className='arrow-wrapper'>
              <ArrowIcon />
            </div>
          </div>
          <div
            className='accordion-detail'
            style={!collapseActive['recycling'] ? { height: 0 } : {}}
          >
            {isClient && (
              <p
                className='content common-editor'
                dangerouslySetInnerHTML={{ __html: recycling?.detailText }}
              ></p>
            )}
          </div>
        </Accordion>
      )}
      <AgeVerification data={productComplianceFloor} ref={ageRef} />
      <ErrorBoundary fallback={null}>
        {weAccept && (
          <>
            <div
              className={`accordion-summary ${!collapseActive['weAccept'] ? 'expanded' : ''}`}
              onClick={() => onGuaranteeClick('weAccept')}
            >
              {/* {weAccept?.icon && <CDNImage src={weAccept?.icon} width={20} height={20} alt="icon" />} */}
              <p>{weAccept?.serviceTitle}</p>
              <div className='arrow-wrapper'>
                <ArrowIcon />
              </div>
            </div>
            <div
              className='accordion-detail'
              style={!collapseActive['weAccept'] ? { height: 0 } : {}}
            >
              {/* <RichComponent className='content' data={weAccept?.serviceContent} /> */}
              <img
                src={imageUtil.concatImgUrlWithoutForceHttps(weAccept?.icon)}
                alt='we_accept_pay'
                style={{
                  paddingTop: '16px',
                  paddingBottom: '6px',
                  width: '100%',
                }}
              />
              {/* <p className="content" dangerouslySetInnerHTML={{ __html: weAccept?.serviceContent }}></p> */}
            </div>
          </>
        )}
      </ErrorBoundary>
    </AssuranceWrapper>
  );
}
export default Assurance;
